export const handleWhatsAppClick = (message = '') => {
    const phone = '+61449992363';
    const encodedMessage = message ? `?text=${encodeURIComponent(message)}` : '';
    const isMobile = /iPhone|Android|iPad|iPod|BlackBerry|webOS/i.test(navigator.userAgent);
    const url = isMobile
      ? `https://wa.me/${phone}${encodedMessage}`
      : `https://web.whatsapp.com/send?phone=${phone}${encodedMessage}`;
  
    const win = window.open(url, '_blank');
    if (!win) {
      window.location.href = `https://wa.me/${phone}${encodedMessage}`;
    }
};
